// extracted by mini-css-extract-plugin
export default {"root":"InvigilationTable_root__+q6VX","student":"InvigilationTable_student__8Uh99","button":"InvigilationTable_button__DNmiQ"};